<script lang="ts" setup>
import BasicText from '~/components/form-elements/BasicText.vue'
import PartnerBox from '~/components/partner/PartnerBox.vue'
import PartnerCube from '~/components/partner/PartnerCube.vue'
import PartnerSubtitle from '~/components/partner/PartnerSubtitle.vue'

const privileges = [
  {
    title: 'Продвинутые IT-инструменты для\xA0работы',
    contents: [
      'Агрегатор списков добавок\xA0— сохраняйте готовые подборки БАД\xA0для\xA0разных запросов.',
      'Конструктор рекомендаций\xA0— создавайте готовые схемы за\xA0пару минут'
    ]
  },
  {
    title: 'ИИ-помощники для\xA0работы с\xA0клиентами',
    contents: [
      '«Foody» – анализирует рацион по\xA0фото, тексту или\xA0голосовому описанию и\xA0помогает корректировать питание',
      '«Витаминный будильник» – не\xA0даст забыть о\xA0приёме добавок'
    ]
  },
  {
    title: 'Закрытое сообщество 2000+ экспертов в\xA0Telegram-канале',
    contents: [
      'Прямые эфиры с\xA0топовыми экспертами',
      'Вебинары от\xA0представителей брендов',
      'Разборы новостей интегративной медицины',
      'Обучение\xA0hard &\xA0soft\xA0skills для\xA0достижения успехов в\xA0работе'
    ]
  },
  {
    title: 'Эсклюзивные мероприятия для\xA0партнёров iTAB',
    contents: [
      'Возможность выступать как\xA0спикер',
      'Розыгрыши билетов и\xA0специальные скидки',
      'Участие в\xA0конференциях iTAB и\xA0наших партнёров',
    ]
  },
  {
    title: 'Обучения по\xA0продуктам, представленным на\xA0iTAB',
    contents: [
      'Возможность повышать свою квалификацию в\xA0сфере подбора БАД',
    ]
  },
  {
    title: 'Акции и\xA0розыгрыши эксклюзивно для\xA0партнёров',
    contents: [
      'Станете участником акций, конкурсов и\xA0розыгрышей',
      'Получите скидки на\xA0мероприятия интегративного мира',
    ]
  }
]
</script>

<template>
  <PartnerBox class="my-2">
    <PartnerSubtitle class="!mb-5 md:!mb-8" subtitle="Став партнёром iTAB, вам&nbsp;будут доступны" />

    <div class="flex w-full flex-col flex-wrap md:flex-row">
      <PartnerCube
        v-for="(x, i) in privileges"
        :key="i"
        class="mb-3 md:mr-3 md:w-[calc(50%-12px)] lg:w-[calc(33%-12px)]"
        :index="i + 1"
        :title="x.title"
      >
        <div v-for="(p, j) in x.contents" :key="j" class="mb-2 flex items-center md:mb-5">
          <div class="mr-3 !size-[5px] rounded-full bg-main-blue" />

          <BasicText :text="p" />
        </div>
      </PartnerCube>
    </div>
  </PartnerBox>
</template>
